import { combineReducers } from 'redux';
import { hackDeepClone } from 'react-redux-app/lib/modules/core/utils';

import {
  ACTION_ADD_PAYOUT_REQUESTS,
  ACTION_CANCEL_PAYOUT_REQUEST__REQUEST,
  ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
  ACTION_CANCEL_PAYOUT_REQUEST__FAIL,
} from '../actionTypes';
import { PAYOUT_STATUS__CANCELED_BY_USER } from '../constants';
import errors from './errors';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_PAYOUT_REQUESTS:
      return { ...state, ...action.payload.payoutRequests };

    case ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS: {
      const currentRequest = hackDeepClone(state[action.payload.payoutRequestId]);
      currentRequest.status = PAYOUT_STATUS__CANCELED_BY_USER;

      return { ...state, [action.payload.payoutRequestId]: currentRequest };
    }

    default:
      return state;
  }
};

const isRequestBeingCanceled = (state = false, action) => {
  switch (action.type) {
    case ACTION_CANCEL_PAYOUT_REQUEST__REQUEST:
      return true;

    case ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS:
    case ACTION_CANCEL_PAYOUT_REQUEST__FAIL:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  byId,
  errors,
  isRequestBeingCanceled,
});
